import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('uz');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferred-language');
    if (savedLanguage && ['uz', 'ru'].includes(savedLanguage)) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = (language) => {
    if (['uz', 'ru'].includes(language)) {
      console.log('Dil değiştiriliyor:', language);
      setCurrentLanguage(language);
      localStorage.setItem('preferred-language', language);
    }
  };

  const value = {
    currentLanguage,
    changeLanguage,
    isUzbek: currentLanguage === 'uz',
    isRussian: currentLanguage === 'ru'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};